import React from "react";
import styles from "./style.module.css";

const PageTitle = ({ title, subTitle }) => {
  return (
    <div className={styles.page_title}>
      <div className={styles.title}>{title}</div>
      {subTitle && <div className={styles.sub_title}>{subTitle}</div>}
    </div>
  );
};

export default PageTitle;
